/**
 * @generated SignedSource<<fb3e65a514abf6ff69d7b6adb1eab6d9>>
 * @relayHash bf87e192c54f91a66ced771e71a83e95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ff79aed9b86267ef2c6a6d3832ae25239618cb8d60cf74d7f9c27d6ee131c3c6

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type AppNavigationUnifiedQuery$variables = Record<PropertyKey, never>;
export type AppNavigationUnifiedQuery$data = {
  readonly lookAndFeel: {
    readonly custom: {
      readonly horizontalHeader: {
        readonly backgroundColor: string | null;
        readonly primaryNavigation: {
          readonly highlightColor: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly siteConfiguration: {
    readonly customSiteLogo: boolean;
  } | null;
  readonly siteDescription: {
    readonly logoUrl: string | null;
  } | null;
  readonly siteSettings: {
    readonly showApplicationTitle: boolean;
    readonly siteTitle: string;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type AppNavigationUnifiedQuery = {
  response: AppNavigationUnifiedQuery$data;
  variables: AppNavigationUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "LookAndFeelSettings",
    "kind": "LinkedField",
    "name": "lookAndFeel",
    "plural": false,
    "selections": [
      {
        "concreteType": "LookAndFeel",
        "kind": "LinkedField",
        "name": "custom",
        "plural": false,
        "selections": [
          {
            "concreteType": "HeaderLookAndFeel",
            "kind": "LinkedField",
            "name": "horizontalHeader",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "backgroundColor"
              },
              {
                "concreteType": "NavigationLookAndFeel",
                "kind": "LinkedField",
                "name": "primaryNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "highlightColor"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "SiteConfiguration",
    "kind": "LinkedField",
    "name": "siteConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "customSiteLogo"
      }
    ]
  },
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "siteTitle"
      },
      {
        "kind": "ScalarField",
        "name": "showApplicationTitle"
      }
    ]
  },
  {
    "concreteType": "SiteDescription",
    "kind": "LinkedField",
    "name": "siteDescription",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "logoUrl"
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppNavigationUnifiedQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppNavigationUnifiedQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bf87e192c54f91a66ced771e71a83e95",
    "id": "ff79aed9b86267ef2c6a6d3832ae25239618cb8d60cf74d7f9c27d6ee131c3c6",
    "metadata": {},
    "name": "AppNavigationUnifiedQuery",
    "operationKind": "query",
    "text": "query AppNavigationUnifiedQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}},siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},confluence{permissionType}}}"
  }
};
})();

(node as any).hash = "619f7ed5bf8c55063c547ebd35234b66";

export default node;
